module.exports = __webpack_public_path__ + "media/assets/images/category/MusicVideos@2x-7c19408a7173e843c04089a36a4cc168.png";